import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const STTypographyGlobalSearch = styled(Typography)`
  padding-left: 16px;
  && {
    color: rgba(0, 0, 0, 0.87);
    font-size: 1rem;
    font-weight: 400;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    line-height: 1.5em;
  }
`;

export const STHeaderWrapper = styled.div`
  padding: 20px 22px 8px;
`;

export const STMainContentWrapper = styled.div`
  padding-bottom: 2rem;
`;
